export const handleAvatar = (avatarURL?: string) => {
  if (!avatarURL) return;
  if (avatarURL.includes('gravatar.com')) {
    return avatarURL;
  } else {
    const timestamp = Date.now();
    return `${avatarURL}?t=${timestamp}`;
  }
};
